import { useEffect, useState } from "react";
import { ModelComputeService } from "services/ModelComputeService";

const useActiveHotWords = (modelComputeService: ModelComputeService) => {
    const [txHotWords, setTxHotWords] = useState<string[]>([]); // this is the custom vocab section
    const [redactHotWords, setRedactHotWords] = useState<string[]>([]);
    const [txHotWordsIsEnabled, setTxHotWordsIsEnabled] = useState(false);
    const [redactHotWordsIsEnabled, setRedactHotWordsIsEnabled] =
        useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (txHotWords && txHotWords.length > 0) {
            setTxHotWordsIsEnabled(true);
        }
    }, [txHotWords]);

    useEffect(() => {
        if (redactHotWords && redactHotWords.length > 0) {
            setRedactHotWordsIsEnabled(true);
        }
    }, [redactHotWords]);

    useEffect(() => {
        const runFn = async () => {
            try {
                setIsLoading(true);
                const res = await modelComputeService.getActiveHotWords();
                const txWords = res.transcription.map((word) => word.word);
                const redactWords = res.redaction.map((word) => word.word);
                setTxHotWords(txWords);
                setRedactHotWords(redactWords);
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        runFn();
    }, [modelComputeService]);

    return {
        txHotWords,
        setTxHotWords,
        txHotWordsIsEnabled,
        setTxHotWordsIsEnabled,
        redactHotWords,
        setRedactHotWords,
        redactHotWordsIsEnabled,
        setRedactHotWordsIsEnabled,
        isLoading,
    };
};

export default useActiveHotWords;
